import { render, staticRenderFns } from "./ProductInfoManual.vue?vue&type=template&id=fec97348&scoped=true&"
import script from "./ProductInfoManual.vue?vue&type=script&lang=ts&"
export * from "./ProductInfoManual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec97348",
  null
  
)

export default component.exports